import "@/App.css";
import { ThemeProvider } from "@/hooks/useTheme";
import { AuthProvider } from "@/hooks/useAuth";
import { useState, useCallback, useEffect } from "react";
import Dashboard from "@/pages/Dashboard";
import LandingPage from "@/pages/LandingPage";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import AdminDashboard from "@/pages/AdminDashboard";
import PaymentSuccess from "@/pages/PaymentSuccess";
import AuthCallback from "@/components/AuthCallback";
import AuthModal from "@/components/AuthModal";

function App() {
  const [page, setPage] = useState("landing");
  const [initialTab, setInitialTab] = useState(null);
  const [initialStock, setInitialStock] = useState(null);
  const [prefetchedStocks, setPrefetchedStocks] = useState(null);

  // URL-based page detection
  useEffect(() => {
    const path = window.location.pathname;
    if (path.startsWith("/payment/success")) {
      setPage("payment-success");
    }
  }, []);

  const handleAuthComplete = useCallback(() => {
    // After sign-in, stay on the current page (don't force dashboard)
    // If on landing page, stay there so user sees their signed-in state
  }, []);

  const handleEnterScreener = useCallback((tab, ticker) => {
    setInitialTab(tab || null);
    setInitialStock(ticker || null);
    setPage("dashboard");
    window.scrollTo(0, 0);
  }, []);

  return (
    <ThemeProvider>
      <AuthProvider>
        <AuthCallback onComplete={handleAuthComplete} />
        <AuthModal />
        {page === "landing" && (
          <LandingPage onEnterScreener={handleEnterScreener} onNavigate={setPage} onStocksFetched={setPrefetchedStocks} />
        )}
        {page === "privacy" && <PrivacyPolicy onBack={() => setPage("landing")} />}
        {page === "admin" && <AdminDashboard onBack={() => setPage("dashboard")} />}
        {page === "payment-success" && <PaymentSuccess onNavigate={(p) => { window.history.replaceState({}, "", "/"); setPage(p); }} />}
        {page === "dashboard" && (
          <Dashboard onNavigate={setPage} initialTab={initialTab} initialStock={initialStock} prefetchedStocks={prefetchedStocks} />
        )}
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
